import React from 'react';

const testIds = {
    SPEAKER_ICON: 'SPEAKER_ICON'
};

const SpeakerIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-test-id={testIds.SPEAKER_ICON}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22 12.2496C22 9.15539 20.7708 6.18792 18.5829 4L17.4044 5.17852C19.2797 7.05387 20.3333 9.59742 20.3333 12.2496C20.3333 14.9018 19.2797 17.4453 17.4044 19.3206L18.5829 20.4992C20.7708 18.3112 22 15.3438 22 12.2496ZM11.1667 5.58291C11.1667 5.24586 10.9637 4.94199 10.6522 4.81301C10.3408 4.68402 9.98241 4.75532 9.74407 4.99366L5.82149 8.91624H2.83333C2.3731 8.91624 2 9.28934 2 9.74958V14.7496C2 15.2098 2.3731 15.5829 2.83333 15.5829H5.82149L9.74407 19.5055C9.98241 19.7439 10.3408 19.8151 10.6522 19.6861C10.9637 19.5572 11.1667 19.2533 11.1667 18.9163V5.58291ZM6.75592 10.3388L9.5 7.59476V16.9044L6.75592 14.1603L6.51184 13.9163H6.16667H3.66667V10.5829H6.16667H6.51184L6.75592 10.3388ZM15.3334 12.2496C15.3334 10.9235 14.8067 9.65173 13.869 8.71405L12.6904 9.89257C13.3156 10.5177 13.6667 11.3655 13.6667 12.2496C13.6667 13.1336 13.3156 13.9814 12.6904 14.6066L13.869 15.7851C14.8067 14.8474 15.3334 13.5757 15.3334 12.2496ZM16.2257 6.35703C17.7885 7.91983 18.6665 10.0394 18.6665 12.2496C18.6665 14.4597 17.7885 16.5794 16.2257 18.1421L15.0472 16.9636C16.2975 15.7134 16.9998 14.0177 16.9998 12.2496C16.9998 10.4815 16.2975 8.78578 15.0472 7.53554L16.2257 6.35703Z"
            fill="#F9FAFA"
        />
    </svg>
);

export {SpeakerIcon};
